import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../services/language.service';
import { privacyNoticeConfig, privacyNoticeText } from './privacy-notice.config';

@Component({
  selector: 'app-privacy-notice',
  standalone: true,
  template: `<footer class="px-4 py-3 text-center text-sm text-gray-600 dark:text-gray-300">
    <a href="/privacy-policy.html" class="underline hover:text-brand-500">{{ policyLabel }}</a>
  </footer>`,
})
export class PrivacyNoticeComponent implements OnInit, OnDestroy {
  policyLabel = privacyNoticeText.en.policy;
  private subscription?: Subscription;
  private destroyed = false;

  constructor(
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;
    // Bundle locally; no CDN, account, backend, or consent logging endpoint.
    // Dev prebundling and application builds wrap Klaro's CommonJS API differently.
    const klaroModule = await import('klaro');
    const klaro = klaroModule.default ?? klaroModule;
    if (this.destroyed) return;
    const config = privacyNoticeConfig();
    this.subscription = this.languageService.currentLanguage$.subscribe(language => {
      const locale = language === 'pl' || language === 'uk' ? language : 'en';
      this.policyLabel = privacyNoticeText[locale].policy;
      config.lang = locale;
      klaro.render(config);
    });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.subscription?.unsubscribe();
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('wlasnasprawa-privacy-notice')?.remove();
    }
  }
}
